exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".topping-list-form .btn-save{float:right;margin-right:22px}.topping-list-form .card-footer{position:fixed;bottom:0;left:0;right:0;padding:7.75px;border-top:none;margin-top:1.5rem;z-index:999}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/outlets/ToppingExclusionForm.vue"],"names":[],"mappings":"AACA,6BACE,YAAa,AACb,iBAAmB,CACpB,AACD,gCACE,eAAgB,AAChB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,WAAa,CACd","file":"ToppingExclusionForm.vue","sourcesContent":["\n.topping-list-form .btn-save{\n  float: right;\n  margin-right: 22px;\n}\n.topping-list-form .card-footer{\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 7.75px;\n  border-top: none;\n  margin-top: 1.5rem;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a1f33c8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/outlets/ToppingExclusionForm.vue
// module id = 1878
// module chunks = 0